module.exports = __webpack_public_path__ + "img/sbp_det.f196581d.png";